"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BrandLogos", {
    enumerable: true,
    get: function() {
        return BrandLogos;
    }
});
var _react = _interop_require_default(require("react"));
var _components = require("@cmpsr/components");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var _props_backgroundColor;
var BrandLogos = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        "data-testid": "cmpsr.component.brand-logos",
        backgroundColor: (_props_backgroundColor = props.backgroundColor) !== null && _props_backgroundColor !== void 0 ? _props_backgroundColor : "background-page",
        flexDirection: "column",
        alignItems: "center",
        py: {
            base: "3.5rem",
            md: "4rem",
            lg: "5.5rem",
            xl: "7rem"
        },
        px: "2rem"
    }, props));
};
var BrandLogosImagesContainer = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        columnGap: {
            base: "4rem",
            lg: "3.75rem",
            xl: "3.5rem"
        },
        rowGap: {
            base: "2rem",
            md: "2.75rem",
            lg: "4.5rem",
            xl: "7rem"
        },
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        maxWidth: "76.75rem"
    }, props));
};
BrandLogos.ImagesContainer = BrandLogosImagesContainer;
var BrandLogosImage = function(props) {
    return _react.default.createElement(_components.Image, _object_spread({
        maxWidth: {
            base: "10rem",
            md: "11.25rem",
            xl: "12.5rem"
        }
    }, props));
};
BrandLogos.Image = BrandLogosImage;
var BrandLogosTextPairing = function(props) {
    return _react.default.createElement(_components.TextPairing, _object_spread({
        marginBottom: {
            base: "2rem",
            md: "2.75rem",
            lg: "4.75rem"
        }
    }, props));
};
BrandLogosTextPairing.Label = _components.TextPairing.Label;
BrandLogosTextPairing.SubLabel = _components.TextPairing.SubLabel;
BrandLogos.Title = BrandLogosTextPairing;
var BrandLogosOverline = function(props) {
    return _react.default.createElement(_components.Text, _object_spread({
        color: "text-secondary",
        variant: "text-body-display-S",
        textTransform: "uppercase",
        display: "flex",
        marginBottom: "1rem"
    }, props));
};
BrandLogos.Overline = BrandLogosOverline;
